import { render, staticRenderFns } from "./ServersDetail.vue?vue&type=template&id=5c2ac1c7"
import script from "./ServersDetail.vue?vue&type=script&lang=ts"
export * from "./ServersDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports